import { useFieldArray, useWatch } from "react-hook-form";
import { Button, Card, CardBody, CardHeader, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, useDisclosure } from "@nextui-org/react";
import ControlledInput from "../../../../elements/ControlledInput";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import useSWR from "swr";
import { getFetcher } from "../../../../../services/api";
import ControlledReactSelect from "../../../../elements/ControlledReactSelect";
import { useMemo } from "react";
import AddTransporterModal from "../../transporter/AddTransporterModal";

export default function DynamicImportData({ control, setValue, isDisabled = false, errors, dataRegistration, selectedCompany, dataTransporter, mutateTransporter, isLoadingTransporter }) {
  const { isOpen: isOpenModalForm, onOpen: onOpenModalForm, onOpenChange: onOpenChangeModalForm, onClose: onCloseModalForm } = useDisclosure();

  const purchaseSum = useWatch({ control, name: "dataImport" });
  const { fields, append, remove } = useFieldArray({ control, name: "dataImport" });

  const totalDistribution = Array.isArray(purchaseSum)
    ? purchaseSum.reduce((total, field) => {
        const value = parseFloat(field.jumlahBahanB3DiBeli) || 0;
        // Bulatkan agar galat floating point (0.1 + 0.2 = 0.30000000000000004) tidak ikut tampil/tersimpan
        const sum = Number((total + value).toFixed(6));
        setValue("jumlahPembelianB3", sum);
        return sum;
      }, 0)
    : 0;

  const pelabuhanBongkarIds = dataRegistration?.BahanB3Registrasi?.[0]?.pelabuhan_bongkar?.join(",") || "";
  const { data: dataPelabuhanBongkar, isLoading: isLoadingPelabuhanBongkar } = useSWR(pelabuhanBongkarIds ? `/api/data-pelabuhan/search?returnAll=false&id_lokasi=${pelabuhanBongkarIds}&limit=999` : null, getFetcher);

  console.log("data registrasi", dataRegistration);

  // Transform data pelabuhan untuk react-select
  const pelabuhanOptions = useMemo(() => {
    if (!dataPelabuhanBongkar?.data) return [];

    return dataPelabuhanBongkar.data.map((item) => ({
      value: item.id,
      label: `${item.id_lokasi} - ${item.nm_lokasi}`,
    }));
  }, [dataPelabuhanBongkar]);

  return (
    <>
      <>
        <Card radius="sm">
          <CardHeader className="text-sm flex justify-between">
            <span>
              Data Impor <span className="text-danger ml-0.5">*</span>
            </span>
            <Button size="sm" isDisabled={isDisabled} onPress={onOpenModalForm} color="primary" startContent={<PlusIcon className="size-4" />}>
              Tambah Perusahaan Transporter
            </Button>
          </CardHeader>
          <CardBody>
            <div className="flex items-center gap-3 mb-3">
              <Button size="sm" isDisabled={isDisabled} onPress={() => append({ pelabuhanBongkarId: "", dataTransporters: [], tanggalImport: null, jumlahBahanB3DiBeli: 0 })} color="primary" startContent={<PlusIcon className="size-4" />}>
                Tambah
              </Button>
              <span className="text-sm">
                Total Impor: <strong>{totalDistribution}</strong>
              </span>
            </div>
            <Table removeWrapper aria-label="table-customer">
              <TableHeader>
                <TableColumn className="w-1/4">Pelabuhan Bongkar</TableColumn>
                <TableColumn className="w-1/2">Perusahaan Transporter</TableColumn>
                <TableColumn className="w-1/5">Tanggal Clearance</TableColumn>
                <TableColumn className="w-1/6">Jumlah Pembelian B3 (KG)</TableColumn>
                <TableColumn>Aksi</TableColumn>
              </TableHeader>
              <TableBody>
                {fields.map((field, index) => (
                  <TableRow key={index}>
                    <TableCell>
                      <ControlledReactSelect
                        control={control}
                        label=""
                        name={`dataImport[${index}].pelabuhanBongkarId`}
                        placeholder="Pilih pelabuhan"
                        options={pelabuhanOptions}
                        isLoading={isLoadingPelabuhanBongkar}
                        menuPosition="fixed"
                        menuPortalTarget={document.body}
                      />
                    </TableCell>
                    <TableCell>
                      <ControlledReactSelect
                        control={control}
                        name={`dataImport[${index}].dataTransporters`}
                        label=""
                        isMulti
                        options={dataTransporter?.data?.map((item) => ({ value: item.id, label: item.namaTransPorter }))}
                        isLoading={isLoadingTransporter}
                        menuPortalTarget={document.body}
                      />
                    </TableCell>
                    <TableCell>
                      <ControlledInput type="date" label="" name={`dataImport[${index}].tanggalImport`} isRequired={true} control={control} />
                    </TableCell>
                    <TableCell>
                      <ControlledInput type="number" label="" name={`dataImport[${index}].jumlahBahanB3DiBeli`} isRequired={true} control={control} />
                    </TableCell>
                    <TableCell>
                      <Button color="danger" size="sm" isIconOnly onClick={() => remove(index)} isDisabled={fields.length === 1}>
                        <TrashIcon className="size-4" />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {errors?.dataImport && <span className="text-xs text-danger">{errors?.dataImport?.message}</span>}
          </CardBody>
        </Card>

        <AddTransporterModal isOpen={isOpenModalForm} onOpenChange={onOpenChangeModalForm} onClose={onCloseModalForm} selectedCompany={selectedCompany} mutateTransporter={mutateTransporter} />
      </>
    </>
  );
}
